import { render, staticRenderFns } from "./RegistrationClosed.vue?vue&type=template&id=c8cf2fa0&scoped=true&"
var script = {}
import style0 from "./RegistrationClosed.vue?vue&type=style&index=0&id=c8cf2fa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cf2fa0",
  null
  
)

export default component.exports